import { Button, Divider, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import BilanturiTable from './BilanturiTable';
import ClientiFinanciar from './ClientiFinanciar';
import DialogEditBilant from './Dialogs/DialogEditBilant';


export default class DateDespreBilant extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            bilanturi: [{ an: 0 }],
            openDeleteBilant: false,
            openEditBilant:false,
            clienti: [],
            alertView:false
        }
    }

    componentDidMount() {
        this.access()

        this.getData()
    }


    ws = new Ws()
    u = new Utils()
    ls = new LocalStorage().GetUserData()

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.AccessFinanciar === 1 ? false : true })
        }


    }


    getData = async () => {


        let getBilanturi = await this.ws.customSelect('select * from fin_import_bilant_head where id = @p1 and isnull(sters,0) != 1', {
            p1: this.props.match.params.idBilant
        })



        console.log('getBilanturi :>> ', getBilanturi);


        if (getBilanturi.Succes) {

            let _getBilantRows =  this.ws.customSelect('select * from fin_import_bilant_rows where id_head = @p1', {
                p1:  this.props.match.params.idBilant
            })




            let _getClienti =  this.ws.customSelect('select * from fin_import_raport_lunar_clienti_head where an = @p1 and isnull(sters,0) != 1 order by id desc', {
                p1: getBilanturi.Content[0].an
            })


            let [getBilantRows, getClienti] = await Promise.all([_getBilantRows, _getClienti])


            if(getClienti.Succes && getBilantRows.Succes){

                console.log('getBilantRows :>> ', getBilantRows);
                let clientiH = [...getClienti.Content]


                if (clientiH.length > 0) {
                    clientiH = [clientiH[0]]
                    console.log('clientiH :>> ', clientiH);
    
    
    
                    let clientiRows = await this.ws.customSelect('select * from fin_import_raport_lunar_clienti_rows where id_head = (select max(id) from fin_import_raport_lunar_clienti_head where an = @p1 ) and isnull(sters,0) != 1', {
                        p1:getBilanturi.Content[0].an
                    })
    
    
                    if(clientiRows.Succes){

                        let bRows = [...getBilantRows.Content]

                        let bilanturi = [...getBilanturi.Content]
    
    
    
                        let bilanturiNew = []
                    for(let i = 0 , n = bilanturi.length; i< n ; i++){
    
                        let idxCifraAfaceri = bRows.findIndex(r => r.id_head === bilanturi[i].id && r.descriere.toLowerCase().includes('cifra de afaceri'))
    
                        console.log('idxCifraAfaceri :>> ', idxCifraAfaceri);
    
                       let bilant = bilanturi[i]
    
                        if(idxCifraAfaceri !== -1){
                            bilant['cifra_afaceri'] = bRows[idxCifraAfaceri]['sold_final']
                        }else{
                            bilant['cifra_afaceri'] = 0
                        }


                        let bilanturiRows = bRows.filter(br => br.id_head === bilanturi[i].id)

                        bilant['rows'] = bilanturiRows
    
                        bilanturiNew.push(bilant)
                      
    
                  
    
                    }
    
                        let clienti = [...clientiRows.Content]
    
                        if(clienti.length > 0 ){
    
                            clientiH[0].nr_clienti = [...new Set(clienti.map(c => c.localitate))].length
    
                            // console.log('clientiLength :>> ', clientiLength);
    
                            console.log('clienti :>> ', clienti);
    
                            clientiH[0].nr_facturi_sold = clienti.filter(c =>c.document && c.document.length > 0).length
    
                            clientiH[0].total_sold = 0
    
                            for(let i = 0 ,n = clienti.length; i < n ; i++ ){
    
                                if(clienti[i].document && clienti[i].document.length > 0){
                                    clientiH[0].total_sold += clienti[i].rest
                                }
                            }
    
                            clientiH[0].total_sold = this.u.toFixedIfNecessary(clientiH[0].total_sold, 2)
    
    
    
                        }
    
                        console.log('clientiRows :>> ', clientiRows);
    
                        console.log('bilanturi :>> ', bilanturiNew);
                        this.setState({
                            bilanturi: bilanturiNew,
                            clienti: clientiH
                        })
    
                    }
    
                   
    
    
                } else {
                    let insertClientiH = await this.ws.insert('fin_import_raport_lunar_clienti_head', { an: getBilanturi.Content[0].an, luna: getBilanturi.Content[0].luna })
    
                    if (insertClientiH.Succes) {
    
                        this.getData()
    
                    }
                }
    
    
    

            }

           

        }

    }

   


    openDeleteBilant = (b) => {

        console.log('b :>> ', b);

        this.setState({
            bilant: b,
            openDeleteBilant: true
        })
    }


    editBilant = (b)=>{ 
        this.setState({openEditBilant:true})
    }

    editClienti = (c) =>{ 
        this.props.history.push(`/clientirows/${c.id}`)
    }


    inapoi = () => {
        this.props.history.goBack()
    }


    changeValoare = (ev, idx) =>{
        let val = ev.target.value
        let n = ev.target.name

        let bilant = [...this.state.bilanturi]


       bilant[0]['rows'][idx][n] = val

       console.log('bilantRowsChange :>> ', bilant[0]['rows'][idx]);

       this.setState({bilanturi:bilant})


        
    }


    onBlurValoare = async(idx, n) =>{

        let bilant = [...this.state.bilanturi]

        console.log('bilantBlur :>> ',      bilant[0]['rows'][idx]);


        let updateBilantRows = await this.ws.update('fin_import_bilant_rows', {[n]:bilant[0]['rows'][idx][n]} ,
                                                                            {id_head:bilant[0]['rows'][idx]['id_head'],
                                                                            descriere: bilant[0]['rows'][idx]['descriere']})



        


   
    }



    render() {
        return (
            <div>

                <CustomAppBar history={this.props.history} title='' />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                <DialogEditBilant
                    open={this.state.openEditBilant}
                    dialogClose={()=>{this.setState({openEditBilant:false})}}
                    bilant={this.state.bilanturi}
                    changeValoare ={this.changeValoare}
                    onBlurValoare={this.onBlurValoare}

                    />

                <AlertNew
                    open={this.state.openDeleteBilant}
                    dialogClose={() => { this.setState({ openDeleteBilant: false }) }}
                    title={'Sunteti sigur ca vreti sa stergeti bilantul selectat ?'}
                    mesaj={'Odata sters, bilantul nu va mai putea fi recuperat !'}
                    yesFunction={this.deleteBilant}
                />


                <Grid style={{ maxWidth: 1200, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.financiar.bilantAnual} {this.state.bilanturi[0].an} </h1>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.bilanturi.length > 0 &&
                                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>



                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.informatiiDespreBilant} </h5>


                                        <Divider className='pm-divider' />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                        <BilanturiTable
                                            bilanturi={this.state.bilanturi}
                                            deleteBilant={this.openDeleteBilant}
                                            editBilant={this.editBilant}
                                            dictionary={this.dictionary}
                                            dontShowDelete={true}
                                            dontShowClienti={true}
                                        />







                                    </Grid>


                                    <Grid style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'add-button-blue'} onClick={()=>{this.editBilant(this.state.bilanturi[0])}}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>edit</i>  {this.dictionary.financiar.editeazaBilant}
                                        </Button>

                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'inapoi-button-blue'} onClick={this.inapoi}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>keyboard_arrow_left</i>  {this.dictionary.financiar.inapoi}
                                        </Button>
                                    </Grid>






                                </Grid>
                            }


                          



                            <ClientiFinanciar
                                clientiHead={this.state.clienti}
                                editClienti={this.editClienti}
                                // addClienti={this.addClienti}
                                inapoi={this.inapoi}
                            />


                        </Grid>



                    </Grid>





                </Grid>
            </div>
        );
    }
}